import { TicketsSold } from 'features/Dashboard/components/tixologist/TicketsSold';

import * as Styled from '../AnalyticByEvent.styles';

const TicketsSoldSection: React.FC = () => (
	<Styled.AnalyticsContainer>
		<TicketsSold />
	</Styled.AnalyticsContainer>
);

export default TicketsSoldSection;
